import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { ScenarioRevenueExt } from '@/classes/scenario/ren-fr/revenue/ScenarioRevenueExt';

const getDefaultFields = () => new ScenarioRevenueExt();

export const buildRevenueModule = () => {

  @Module({
    namespaced: true
  })
  class RevenueModule extends VuexModule {

    private presets: Record<string, string | number> | null = null;

    @Mutation
    private setPresets(payload: Record<string, string | number> | null) {
      this.presets = payload;
    }

    get getConfig(): ScenarioExt {
      return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
    }

    get getFields(): ScenarioRevenueExt {
      return this.getConfig.revenue ? new ScenarioRevenueExt(this.getConfig.revenue) : getDefaultFields();
    }

    get getPresets(): Record<string, string | number> | null {
      return this.presets;
    }
  }

  return RevenueModule;
};
